import actions from './actions';

const {
  GET_VEHICLE_COLOR_BEGIN, GET_VEHICLE_COLOR_SUCCESS, GET_VEHICLE_COLOR_FAILED,
  ADD_VEHICLE_COLOR_BEGIN, ADD_VEHICLE_COLOR_SUCCESS, ADD_VEHICLE_COLOR_FAILED,
  UPDATE_VEHICLE_COLOR_BEGIN, UPDATE_VEHICLE_COLOR_SUCCESS, UPDATE_VEHICLE_COLOR_FAILED,
  DELETE_VEHICLE_COLOR_BEGIN, DELETE_VEHICLE_COLOR_SUCCESS, DELETE_VEHICLE_COLOR_FAILED,
} = actions;

const initState = {
  total: 0,
  currentPage: 1,
  pageLimit: 8,
  colors: [],
  loading: false,
  error: null,
};

const VehicleColorReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_VEHICLE_COLOR_BEGIN:
      return {
        ...state,
        total: 0,
        colors: [],
        loading: true,
      };
    case GET_VEHICLE_COLOR_SUCCESS:
      return {
        ...state,
        total: data.total,
        colors: data.vehicleAvailableColors,
        currentPage: data.currentPage || state.currentPage,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.currentPage ? false : true,
      };
    case GET_VEHICLE_COLOR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_VEHICLE_COLOR_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_VEHICLE_COLOR_SUCCESS:
      return {
        ...state,
        total: state.total + 1,
        colors: data,
        loading: false,
      };
    case ADD_VEHICLE_COLOR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_VEHICLE_COLOR_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_VEHICLE_COLOR_SUCCESS:
      return {
        ...state,
        colors: data,
        loading: false,
      };
    case UPDATE_VEHICLE_COLOR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_VEHICLE_COLOR_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_VEHICLE_COLOR_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        colors: data,
        loading: false,
      };
    case DELETE_VEHICLE_COLOR_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default VehicleColorReducer;